import React from "react";
import { BookOpen } from "lucide-react";

import { Button } from "../components/Button.jsx";
import { brand } from "../theme/theme";

export function TutorialStartButton({ onClick, label = "Ver tutorial", size }) {
  return (
    <Button
      variant="white"
      size={size}
      onClick={onClick}
      sx={{
        backgroundColor: brand.soft,
        color: brand.softText,
        borderColor: brand.softBorder,
        "&:hover": { backgroundColor: brand.soft, borderColor: brand.pink, boxShadow: "none" },
      }}
    >
      <BookOpen size={16} />
      {label}
    </Button>
  );
}
